<template>
    <v-stepper v-bind="{ ...$attrs, value }" elevation="0" class="d-flex flex-column">
        <!-- stepper header -->
        <v-stepper-header v-bind="$attrs.headerProps || {}" class="elevation-0 border mb-40 mb-lg-60" style="flex: 0 0 auto">
            <template v-for="{ step, text, complete, editable } in steps">
                <v-stepper-step :key="`${step}-step`" v-bind="{ step, complete, editable }" @click="$emit('input', step)">
                    <i :class="'mb-12 mb-lg-20 icon icon-step icon-step--'+step"></i>
                    <h5 class="v-stepper__step__title page-text--lg mb-2">
                        STEP {{step}}
                    </h5>
                    <p class="v-stepper__step__detail page-text--sm">{{ text }}</p>
                </v-stepper-step>
            </template>
        </v-stepper-header>
        <!-- stepper contents -->
        <v-stepper-items v-bind="$attrs.itemsProps || {}" style="flex: 0 1 auto; overflow-y: auto">
            <template v-for="{ step, node } in steps">
                <v-stepper-content :key="`${step}-content`" v-bind="{ step }">
                    <slot v-if="$slots[step]" :name="step" />
                    <v-node v-else-if="node" v-bind="{ node }" />
                </v-stepper-content>
            </template>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
export default {
    components: {
        vNode: { functional: true, render: (h, ctx) => ctx.props.node },
    },
    props: {
        value: { type: [Number, String], default: 1 }, // step
        steps: { type: Array, default: () => [] },
    },
};
</script>

<style lang="scss" scoped>
::v-deep{
    .v-stepper{
        &__header{
            height: auto;
            padding: 16px;
            justify-content: center;
            border-radius: 10px;

        }
        &__step{
            padding: 10px;
            width: 50%;
            &__step{
                display: none;
            }
            &__title{
                line-height: 1.35;
                color: var(--v-grey-base);
            }
            &__detail{
                line-height: 1.35;
                color: #999;
            }
            &--active{
                .v-stepper__step__title{
                    color: var(--v-primary-base);
                }
                .v-stepper__step__detail{
                    color: #131313;
                }
            }
        }
        &__label{
            margin: 0 auto;
            cursor: pointer;
            display: flex !important;
            flex-direction: column;
            align-items: center;
            min-width: 96px;
        }
        &__content{
            padding: 0;
        }
    }
}
@media (min-width:576px){
    ::v-deep{
        .v-stepper{
            &__header{
                padding: 20px;
                margin: 0;
            }
            &__step{
                width: auto;
                padding: 0 16px;
            }
        }
    }
}
@media (min-width:768px){
    ::v-deep{
        .v-stepper{
            &__header{
                padding: 30px 20px;
            }
            &__label{
                position: relative;
                &::after{
                    content: "";
                    display: block;
                    position: absolute;
                    width: 15px;
                    height: 26px;
                    background-image: url(/images/icon/icon-right-arrow-grey.svg);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                    top: 27px;
                    right: -10px;
                    transform: translateX(100%);
                }
            }
            
            &__step:last-child{
                .v-stepper__label::after{
                    display: none;
                }
            }
        }
    }
}
@media (min-width:1024px){
    ::v-deep{
        .v-stepper{
            &__header{
                padding: 60px 20px;
                border-radius: 20px;

            }
            &__step{
                padding: 0 37px;
            }
            &__label{
                min-width: 120px;
                &::after{
                    top: 37px;
                    right: -31px;
                }
            }
        }
    }
}
@media (min-width:1200px){
}

</style>
